import { createRoot } from 'react-dom/client';
import { useEffect, useState, createRef, type JSX } from 'react';
import {
    getStringAttribute,
    getYesAttribute,
} from '@repo/widget-utils/attributes/attribute-helper';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';
import Booking from '../activity-booking/booking/Booking';
import { BookingContextProvider } from 'src/widgets/BookingContext';
import { showSessionSelectorAtom } from 'src/components/domain/timeslots-booking/calendar/booking-timeslots/BookingTimeslots';

export function BookingInline(props: {
    productCatalogId: string;
    isTimeslots: boolean;
    isAccommodation: boolean;
    mountPoint: HTMLDivElement;
    popoverMountPoint: HTMLDivElement;
    shadowRoot: ShadowRoot;
    dateSelectionFirst: boolean;
}): JSX.Element {
    const ref = createRef<HTMLDivElement>();
    const [popoverMountPoint, setPopoverMountPoint] = useState<HTMLDivElement | null>(null);
    useEffect(() => {
        if (ref.current) setPopoverMountPoint(ref.current);
    }, [ref]);

    return (
        <WidgetWrapper
            mountPoint={props.mountPoint}
            popoverMountPoint={popoverMountPoint ?? props.popoverMountPoint}
            shadowRoot={props.shadowRoot}
        >
            <BookingContextProvider initialTicketOptions={[]}>
                <Booking
                    productCatalogId={props.productCatalogId}
                    isInlineBooking={true}
                    isTimeslots={props.isTimeslots}
                    isAccommodation={props.isAccommodation}
                    dateSelectionFirst={props.dateSelectionFirst}
                />
            </BookingContextProvider>
        </WidgetWrapper>
    );
}
class BilberryBookingInline extends BilberryCustomElement {
    protected renderWidget(): void {
        const productCatalogId = getStringAttribute(this, 'product-catalog-id', false) ?? '';
        const isTimeslots = getYesAttribute(this, 'timeslots');
        const isAccommodation = getYesAttribute(this, 'accommodation');
        const dateSelectionFirst = getYesAttribute(this, 'date-selection-first');
        // Opt-in timeslot session-length selector — pushed to the global atom that
        // BookingTimeslots reads, so it isn't prop-drilled through the calendar tree.
        const showSessionSelector = getYesAttribute(this, 'show-session-selector');
        showSessionSelectorAtom.update(showSessionSelector);

        createRoot(this._mountPoint).render(
            <BookingInline
                productCatalogId={productCatalogId}
                isTimeslots={isTimeslots}
                isAccommodation={isAccommodation}
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
                dateSelectionFirst={dateSelectionFirst}
            />,
        );
    }
}

export default function defineCustomElement(): void {
    customElements.define('bilberry-booking-inline', BilberryBookingInline);
}
